export default __webpack_public_path__ + "static/media/patio-res7.f601bf37.jpg";